import CommonLayout from "../../layout/CommonLayout";
import CommonMenu from "../../layout/CommonMenu";
import CommonFooter from "../../layout/CommonFooter";
import { Link } from "react-router-dom";

const GNBPURE05001S = () => {

  return (
	<CommonLayout>
      <CommonMenu />
		<>
            <div id="contents" className="container">
                <div className="sub-title bg-type05">
                    <h2>개인정보처리방침</h2>
                </div>

                <div id="cont" className="cont">
                    <div className="inner">

                        {/* 탭 메뉴 */}
                        <div className="tabs ty02">
                            <ul className="tab-item col03">
                                <li className="on">
                                    <Link to="/GNBPURE05001S">개인정보처리방침</Link>
                                </li>
                                <li>
                                    <Link to="/GNBPURE05002S">이용약관</Link>
                                </li>
                                <li>
                                    <Link to="/GNBPURE05003S">이메일 무단수집공고</Link>
                                </li>
                            </ul>
                        </div>

                        {/* 개인정보처리방침 */}
                            <div className="notice active">

                                <h1 className="contTitle">개인정보취급방침</h1>

                                <div className="cont-wrap">
                                    <div id="sub_contents" className="container-fluid no-padding">
                                        <div className="container sub_contents_area">
                                            <div className="privacy clearfix">
                                                <div className="row personal-1">
                                                    <p>
                                                        <strong className="bold">GnB소프텍</strong>(이하 "회사"이라 함)는 귀하의 개인정보를 중요시하며,
                                                        『정보통신망 이용촉진 및 정보보호 등에 관한 법률』, 『개인정보 보호법』, 『통신비밀보호법』, 
                                                        『전기통신사업법』 등 정보통신 서비스 제공자가 준수하여야 할 관련 법령상의 개인정보보호 규정을 준수하고 있습니다.
                                                        회사는 본 개인정보취급방침을 통하여 귀하가 제공하시는 개인정보가 어떠한 용도와 방식으로 이용되고 있으며, 
                                                        개인정보보호를 위해 어떠한 조치가 취해지고 있는지 알려드립니다.
                                                    </p>
                                                    <p>이 개인정보처리방침의 순서는 다음과 같습니다.</p>
                                                    <p>
                                                        1. 수집하는 개인정보의 항목 및 수집방법 
                                                        <br />
                                                        2. 개인정보의 수집 및 이용목적 
                                                        <br />
                                                        3. 개인정보의 보유 및 이용기간 
                                                        <br />
                                                        4. 개인정보의 파기절차 및 그 방법 
                                                        <br />
                                                        5. 개인정보 제공 및 공유 
                                                        <br />
                                                        6. 개인정보처리의 위탁에 관한 사항 
                                                        <br />
                                                        7. 개인정보의 제3자 제공 
                                                        <br />
                                                        8. 동의철회/ 회원탈퇴 방법 
                                                        <br />
                                                        9. 이용자 및 법정대리인의 권리와 그 행사방법 
                                                        <br />
                                                        10. 개인정보 자동수집장치의 설치/운영 및 그 거부에 관한 사항 
                                                        <br />
                                                        11. 개인정보보호책임자 
                                                        <br />
                                                        12. 개인정보의 안정성 확보장치 
                                                        <br />
                                                        13. 정책 변경에 따른 공지의무
                                                    </p>
                                                </div>
                                                <div className="row">
                                                    <p className="contsubTitle">1. 수집하는 개인정보 항목 및 수집방법</p>
                                                    <p>(1) 수집하는 개인정보의 항목, 이용목적</p>
                                                    <p>가. 게시판 글 작성시 필수 항목</p>
                                                    <table className="table-type table-row">
                                                    <tbody>
                                                        <tr>
                                                        <th>수집 목적</th>
                                                        <th>수집 항목</th>
                                                        </tr>
                                                        <tr>
                                                        <td>자세한 상담을 위한 이메일 또는 게시판 및 유선상담 용도</td>
                                                        <td>이름, 이메일, 휴대전화 번호</td>
                                                        </tr>
                                                    </tbody>
                                                    </table>
                                                    <p>
                                                        *보유기간참조사항: 다만, 관계법령에 의해 보존할 경우 볍령에서 정한 일정 기간동안 별도 보관 됩니다 (아래 3항 참조)
                                                    </p>
                                                    <p>
                                                        나. 그 밖에 고객님의 서비스 이용 과정이나 요청 사항 처리 과정에서 
                                                        아래와 같은 정보들이 자동으로 수집 및 저장될 수 있습니다.
                                                    </p>
                                                    <table className="table-type table-row">
                                                        <tbody>
                                                            <tr>
                                                            <th>수집 목적</th>
                                                            <th>수집 항목</th>
                                                            </tr>
                                                            <tr>
                                                            <td>사용자 홈페이지 이용, 사이트 이용에 대한 문의 민원 등 고객 고충 처리</td>
                                                            <td>IP주소, 접속기록, 단말기 및 환경정보 서비스 이용기록, 쿠키 등</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                    <p>(2) 개인정보 수집방법</p>
                                                    <p>
                                                        회사는 아래와 같은 방법으로 개인정보를 수집합니다:
                                                        <br />
                                                        - 홈페이지 고객 문의/고충 처리시 전화 또는 인터넷을 통한 상담.
                                                    </p>
                                    
                                                    <p className="contsubTitle">2. 수집한 개인정보의 공유 및 제공</p>
                                                    <p>
                                                        회사는 본 개인정보취급방침에 명시적으로 달리 규정된 경우를 제외하고는 고객님의 개인정보를 본 개인정보취급방침의
                                                        개인정보의 수집 및 이용목적에서 정한 범위 내에서만 이용하며, 고객님의 사전 동의 없이 고객님의 개인정보를 다른 목적으로
                                                        이용하거나 제3자에게 제공하지 않습니다.
                                                    </p>
                                    
                                                    <p className="contsubTitle">3. 개인정보의 보유 및 이용기간</p>
                                                    <ul className="bul-dot">
                                                    <li>계약 또는 청약철회 등에 관한 기록: 5년 (전자상거래 등에서의 소비자보호에 관한 법률)</li>
                                                    <li>소비자의 불만 또는 상담, 분쟁처리에 관한 기록: 3년 (전자상거래 등에서의 소비자보호에 관한 법률)</li>
                                                    <li>방문(전기통신역무 이용사실)에 관한 기록: 3개월 (통신비밀보호법)</li>
                                                    </ul>
                                    
                                                    <p className="contsubTitle">4. 개인정보의 파기 절차 및 방법</p>
                                                    <ul className="bul-dot">
                                                    <li>출력된 개인정보는 분쇄기로 분쇄하여 파기합니다.</li>
                                                    <li>전자적 파일 형태로 저장된 개인정보는 기록을 재생할 수 없는 기술적 방법을 사용하여 삭제합니다.</li>
                                                    </ul>
                                    
                                                    <p className="contsubTitle">5. 개인정보의 위탁</p>
                                                    <ul className="bul-dot">
                                                    <li>회사명: 스카이디자인</li>
                                                    <li>위탁업무 내용: 웹사이트 개발 및 관리</li>
                                                    </ul>
                                    
                                                    <p className="contsubTitle">6. 개인정보의 제3자 제공</p>
                                                    <p>회사는 제3자에게 개인정보를 제공한 내역이 없습니다.</p>
                                    
                                                    <p className="contsubTitle">7. 고객 및 법정대리인의 권리, 의무 및 그 행사방법</p>
                                                    <p>귀하는 온라인 게시판 1:1 상담을 통해 등록된 개인정보에 관해서는 "비밀번호" 입력 후 삭제하실 수 있습니다.</p>
                                    
                                                    <p className="contsubTitle">8. 쿠키 자동수집 장치의 설치/운영 및 그 거부에 관한 사항</p>
                                                    <ul className="bul-dot">
                                                    <li>쿠키 등 사용 목적</li>
                                                    <li>쿠키 설정 거부 방법</li>
                                                    </ul>
                                    
                                                    <p className="contsubTitle">9. 기술적인 부분 관련 내용</p>
                                                    <p>회사는 귀하의 개인정보를 취급함에 있어 개인정보가 분실, 도난, 누출, 변조 또는 훼손되지 않도록 보호하고 있습니다.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    </div>
                </div>
            </div>  
                 
		  <CommonFooter />
		</>
	</CommonLayout>
  );
};

export default GNBPURE05001S;
